module.exports = __webpack_public_path__ + "img/1.b1984b4f.png";